export default __webpack_public_path__ + "static/media/mobile_seasonpass.69b099e7.webp";